import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const queryParameters = new URLSearchParams(window.location.search);
let source = queryParameters.get('source') || null;
let ad = queryParameters.get('ad') || null;
let refDate = queryParameters.get('refDate' || null);

const learnMoreLink = `https://www.torontotechgear.com/?source=${
  source ? source : ''
}&ad=${ad ? ad : ''}&refDate=${refDate ? refDate : ''}`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App learnMoreLink={learnMoreLink} />
  </React.StrictMode>
);
